<template>
  <transition name="modal">
    <div class="modal-mask-product">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">

          <div class="form-card__header">
            <h6 class="form-card__title">
              <i class="bi bi-wallet2"></i>
              M&eacute;todos de pago
            </h6>
            <button type="button" class="form-card__btn" @click="modified">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>

          <div class="modal-body form-card form-card--bare">

            <div
              v-if="limited && header.pos != 0 && total >= 500000 && (header.letter === 'C' || header.letter === 'B')"
              class="alert alert-danger mb-3">
              Record&aacute; que para realizar una factura igual o mayor a $ 500.000 ten&eacute;s que informar a la ARCA todos los datos del cliente.
            </div>

            <!-- SUMMARY -->
            <div class="payment-summary">
              <div class="total-row total-final">
                <span class="label">Total a pagar</span>
                <span class="value">$ {{ round(total, 2) }}</span>
              </div>
              <div class="total-row">
                <span class="label">Efectivo</span>
                <span class="value">$ {{ payarray.cash || 0 }}</span>
              </div>
              <div class="total-row">
                <span class="label">Transferencia</span>
                <span class="value">$ {{ totalTransfer }}</span>
              </div>
              <div v-for="tpcheck in payarray.tpchecks" :key="'chk-' + tpcheck.number" class="total-row">
                <span class="label">Cheque N&deg; {{tpcheck.number}}</span>
                <span class="value">$ {{ round(tpcheck.amount, 2) }}</span>
              </div>
              <div v-for="creditcard in payarray.creditcards" :key="'cc-' + creditcard.coupon" class="total-row">
                <span class="label">{{creditcard.name}} — cup&oacute;n {{creditcard.coupon}}</span>
                <span class="value">$ {{ round(creditcard.amount, 2) }}</span>
              </div>
              <div v-for="(cc, idx) in payarray.accounts" :key="'ac-' + idx" class="total-row">
                <span class="label">Cuenta corriente (venc. {{cc.days}})</span>
                <span class="value">$ {{ cc.amount }}</span>
              </div>
              <div v-if="limited && change > 0" class="total-row">
                <span class="label">Vuelto</span>
                <span class="value text-success">$ {{ round(change, 2) }}</span>
              </div>
              <div v-if="limited && diference != 0" class="total-row">
                <span class="label">Diferencia</span>
                <span class="value text-danger">$ {{ round(diference, 2) }}</span>
              </div>
            </div>

            <div class="totals-divider"></div>

            <!-- FORM -->
            <div class="form-row">
              <div class="form-group col-md-6 mb-2">
                <label class="form-card__label">Efectivo <i class="bi bi-cash"></i></label>
                <label class="form-card__label">Monto</label>
                <input v-model.number="cash" type="number" min="0" step="0.01" class="form-control">
              </div>
              <div class="form-group col-md-6 mb-2">
                <label class="form-card__label"> Caja <i class="bi bi-safe"></i></label>
                <label class="form-card__label">EFECTIVO destino</label>
                <select v-model="payarray.fund_id" class="form-control" name="fund_id">
                  <option v-for="fund in funds" :key="fund.id" :value="fund.id">{{fund.name}}</option>
                </select>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-md-6 mb-2">
                <label class="form-card__label">Transferencia <i class="bi bi-arrow-left-right"></i></label>
                <label class="form-card__label">Monto</label>
                <input
                  v-model.number="transfer"
                  type="number"
                  min="0"
                  step="0.01"
                  class="form-control"
                  @input="updateBanks">
              </div>
              <div class="form-group col-md-6 mb-2">
                <label class="form-card__label"> Caja <i class="bi bi-bank"></i></label>
                <label class="form-card__label">BANCO destino</label>
                <div class="bank-field">
                  <select v-model="fundTransfer" class="form-control" name="fund_id" @change="updateBanks">
                    <option disabled value="0">Seleccione una caja...</option>
                    <option v-for="fundBank in fundsBank" :key="fundBank.id" :value="fundBank.id">{{fundBank.name}}</option>
                  </select>
                  <button type="button" class="btn btn-primary bank-field__add" title="Agregar otra transferencia" @click="addInputSelect">
                    <i class="bi bi-plus-lg"></i>
                  </button>
                </div>
              </div>
            </div>

            <div v-for="(inputSelect, index) in inputSelects" :key="index" class="form-row">
              <div class="form-group col-md-6 mb-2">
                <input
                  v-model.number="inputSelect.input"
                  type="number"
                  min="0"
                  step="0.01"
                  class="form-control"
                  placeholder="0"
                  @input="updateBanks">
              </div>
              <div class="form-group col-md-6 mb-2">
                <div class="bank-field">
                  <select v-model="inputSelect.select" class="form-control" name="fund_id" @change="updateBanks">
                    <option v-for="fundBank in fundsBank" :key="fundBank.id" :value="fundBank.id">{{fundBank.name}}</option>
                  </select>
                  <button type="button" class="btn btn-outline-danger bank-field__remove" title="Quitar esta transferencia" @click="removeInputSelect(index)">
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </div>
            </div>

            <!-- CHILD METHODS (toggleables) -->
            <div v-if="showCreditCard" class="payment-methods__child mt-3">
              <credit-card
                :locked="payarray.creditcards.length > 0"
                v-on:creditcardcancel="creditCardRemove"
                v-on:creditcardsaved="creditCardSave"/>
            </div>
            <div v-if="showTpCheck" class="payment-methods__child mt-3">
              <tp-check v-on:tpcheckcancel="showTpCheck=false" v-on:tpchecksaved="tpCheckSave"/>
            </div>
            <div v-if="showCc" class="payment-methods__child mt-3">
              <client-account v-on:clientAccountSaved="clientAccountSaved" v-on:clientAccountCancel="showCc=false" :total="ccTotal"/>
            </div>

          </div>

          <div class="form-card__footer payment-methods-footer">
            <div class="payment-methods-footer__secondary">
              <button v-if="paymentMethods.cuenta_corriente==1 && header.client_id != 1" type="button" class="btn btn-light" @click="showCc=!showCc">
                <i class="bi bi-card-heading"></i> Cuenta corriente
              </button>
              <button v-if="paymentMethods.tarjetas==1 && genType!='NC'" type="button" class="btn btn-light" @click="showCreditCard=!showCreditCard">
                <i class="bi bi-credit-card"></i> Tarjetas
              </button>
              <button v-if="paymentMethods.cheques==1 && genType!='NC' && header.client_id != 1" type="button" class="btn btn-light" @click="showTpCheck=!showTpCheck">
                <i class="bi bi-bank"></i> Cheques
              </button>
            </div>
            <div class="payment-methods-footer__primary">
              <button v-if="limited" type="button" class="form-card__btn" @click="modified">Cancelar</button>
              <button
                type="button"
                class="form-card__btn form-card__btn--primary"
                :disabled="!(((round(diference, 2) == 0) || (limited == 0)) && payarray.fund_id != 0 && cajasTransferValidas)"
                @click="finishReceipt">
                <i class="bi bi-check-lg"></i>
                Finalizar venta
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import creditCard from './Credit-card.vue';
import clientAccount from './Client-account.vue';
import tpCheck from './Tp-check.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  props: ['total', 'paymentMethods', 'header', 'limited', 'fundDefault', 'genType'],
  data: function() {
    return {
      showCreditCard: false,
      showTpCheck: false,
      showCc: false,
      totalpayed: 0,
      diference: 0,
      change: 0,
      payarray: {
        banks:[],
        cash: 0,
        fund_id: 0,
        fundBanks_id: [],
        accounts: [],
        creditcards: [],
        tpchecks: []
      },
      limitcc: null,
      ccTotal: 0,
      inputSelects: [],
      transfer: 0,
      fundTransfer: 0,
      totalTransfer: 0,
    }
  },
  mounted: function () {
    this.payarray.fund_id = this.fundDefault;
    if (this.header.cc_only == 1){
      this.ccTotal = this.total;
      this.showCc = true;
      this.payarray.cash = 0;
      this.payarray.banks = [{ amount: 0}];
    }else{
      this.transfer = 0;
    }
    // Inicializa banks y fundBanks_id con un slot vacío (amount:0, fund:0) para que
    // el backend (SaleObserver) no falle al hacer ['banks'][0]['amount'] cuando el
    // usuario paga solo con tarjetas u otros métodos y nunca toca Transferencia.
    this.updateBanks();

    this.getFunds();
    this.getLimitCC();
    this.calc();
  },
  computed: {
      ...mapGetters({
        funds: 'funds/cashFunds',
        fundsBank: 'funds/bankFunds'
      }),
      cash: {
            get: function () {
                return this.payarray.cash;
            },
            set: function (value) {
                if (value==''){
                    this.payarray.cash=0;
                }else{
                    this.payarray.cash=value;
                }
            }
        },
      banks: {
          get: function () {
              return this.payarray.banks;
          },
          set: function (value) {
              if (value==''){
                  this.transfer = 0;
              }else{
                  this.transfer = value;
              }
          }
      },
      // Toda línea de transferencia con monto > 0 debe tener una caja banco elegida
      // (no la opción "Seleccione una caja..."). Bloquea el cierre si falta.
      cajasTransferValidas: function () {
        if (this.transfer > 0 && !this.fundTransfer) return false;
        for (var i = 0; i < this.inputSelects.length; i++) {
          if (this.inputSelects[i].input > 0 && !this.inputSelects[i].select) return false;
        }
        return true;
      },
  },
  watch: {
    payarray: {
      handler: function () {
        this.calc();
      }, deep: true
    }
  },
  methods: {
    round: function(value, decimals) {
      return (Number(Math.round(value + 'e' + decimals) + 'e-' + decimals));
    },
    updateBanks() {
      const banks = [{ amount: this.transfer }];
      const fundTransfer = [{fund: this.fundTransfer}];
      const inputSelectsBanks = this.inputSelects.map(select => ({
        amount: select.input,
      }));

      const selectSelectsBanks = this.inputSelects.map(select => ({
        fund: select.select,
      }));
      this.payarray.fundBanks_id = fundTransfer.concat(selectSelectsBanks);
      this.payarray.banks = banks.concat(inputSelectsBanks);
      console.log(this.payarray.fundBanks_id);
      this.calcTotalTransfer();
    },
    addInputSelect() {
      this.inputSelects.push({ input: 0, select: '' });
    },
    removeInputSelect(index) {
      this.inputSelects.splice(index, 1);
      this.updateBanks();
    },
    calcTotalTransfer() {
      this.totalTransfer = this.payarray.banks.reduce((sum, bank) => sum + bank.amount, 0);
    },
    calc: function () {
      this.totalpayed = 0;

      var interestCreditCards = this.payarray.creditcards.map(el => parseFloat(el.interest)).reduce((acc, currentValue) => acc + currentValue, 0);
      var totalCreditCards = this.payarray.creditcards.map(el => el.amount).reduce((acc, currentValue) => acc + currentValue, 0);
      var totalTpChecks = this.payarray.tpchecks.map(el => el.amount).reduce((acc, currentValue) => acc + currentValue, 0);
      var totalAccounts = this.payarray.accounts.map(el => el.amount).reduce((acc, currentValue) => acc + currentValue, 0);

      var withoutcash = this.round(totalCreditCards,2) + this.round(interestCreditCards,2) + this.round(totalTpChecks,2) + this.round(totalAccounts,2);

      var cosa = this.total - withoutcash;

      if(this.payarray.cash==''){
        this.payarray.cash = 0;
      }

      var totalcash = this.payarray.cash;
      var totalbanks = this.totalTransfer;

      this.change = totalcash - totalbanks - cosa;

      this.totalpayed = this.round(totalcash,2) + this.round(withoutcash,2) + this.round(totalbanks,2);
      this.diference = this.round(this.total,2) - this.round(this.totalpayed,2);
    },
    creditCardSave: function(obj) {
      if (this.payarray.creditcards.length > 0) {
        alert('Ya hay un cupón cargado. Quitalo con el botón X si querés cambiarlo.');
        return;
      }
      // Clonamos para no compartir la misma referencia `res` que reusa Credit-card.vue.
      this.payarray.creditcards.push(Object.assign({}, obj));
      this.$emit('paymentmethodschanged',this.payarray);
    },
    creditCardRemove: function() {
      // X en Credit-card.vue: si hay un cupón cargado, lo saca y el form se reactiva.
      if (this.payarray.creditcards.length > 0) {
        this.payarray.creditcards.splice(0, 1);
        this.$emit('paymentmethodschanged', this.payarray);
      }
    },
    tpCheckSave: function(obj) {
      this.payarray.tpchecks.push(obj);
      this.showTpCheck=false;
    },
    fromdateUpdated: function (date) {
      this.header.service_fromdate = date;
    },
    clientAccountSaved: function (obj) {
      this.payarray.accounts.push(obj);
      this.showCc=false;
    },
    modified: function () {
      this.$emit('paymentmethodschanged',{});
      this.$emit('close');
    },
    finishReceipt: function () {
      this.$emit('paymentmethodsclose',this.payarray);
      this.$emit('close');
    },
    ...mapActions({
      getFunds: 'funds/getFunds'
    }),
    getLimitCC() {
      window.axios.get('/api/clients/getLimitClientAccount/'+this.header.client_id)
            .then(response => {
              if(response.data) {
                if(response.data.data < 0) {
                  this.limitcc = 0;
                } else {
                  this.limitcc = response.data.data;
                }
              }
            })
            .catch(error => {
              alert(error);
            })
    }
  },
  components: {
    clientAccount,
    tpCheck,
    creditCard
  }
}
</script>

<style scoped>
.modal-mask-product {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(16, 24, 40, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
}

.modal-dialog {
  margin: 0;
  width: 100%;
  max-width: 880px;
}

.modal-content {
  border: 1px solid var(--border-soft);
  border-radius: 12px;
  box-shadow: 0 12px 32px rgba(16, 24, 40, 0.18);
  overflow: hidden;
}

.modal-body {
  max-height: 75vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px 24px;
}

.bank-field {
  display: flex;
  align-items: stretch;
  gap: 8px;
}

.bank-field__add,
.bank-field__remove {
  flex-shrink: 0;
  width: 42px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.payment-methods-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.payment-methods-footer__secondary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.payment-methods-footer__secondary .btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.payment-methods-footer__primary {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.payment-methods__child {
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  padding: 16px;
  background: var(--surface-subtle);
}

.payment-methods__section-title {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-soft);
  margin: 12px 0 10px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.modal-enter,
.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-content,
.modal-leave-active .modal-content {
  transform: scale(1.02);
}
</style>
